import {SxProps} from '@mui/material';
import {Theme} from '@mui/system';

import {InitialsAvatar} from '~components/common/InitialsAvatar';

interface MaddoxAvatarProps {
  user: string;
  isHighlighted?: boolean;
  sx?: SxProps;
  color?: string;
  width?: number;
  height?: number;
}

function getHighlightedAvatarStyles(theme: Theme): SxProps {
  return {
    outline: 1,
    outlineStyle: 'solid',
    outlineColor: theme.palette.primary.main,
    border: 2,
    borderColor: 'maddox.globalwhite',
  };
}

export function MaddoxAvatar({user, sx, color = 'maddox.black40', isHighlighted, width, height}: MaddoxAvatarProps) {
  return (
    <InitialsAvatar
      name={user}
      size='small'
      sx={[
        {
          fontSize: 10,
          height: height ?? 22,
          width: width ?? 22,
          zIndex: 1,
          boxSizing: 'content-box',
          fontWeight: 'bold',
        },
        (theme) => ({
          ...(isHighlighted ? getHighlightedAvatarStyles(theme) : undefined),
        }),
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      backgroundColor={isHighlighted ? 'primary.main' : color}
    />
  );
}
